import { render, staticRenderFns } from "./ReusableBox.vue?vue&type=template&id=797ec22e"
import script from "./ReusableBox.vue?vue&type=script&lang=js"
export * from "./ReusableBox.vue?vue&type=script&lang=js"
import style0 from "./ReusableBox.vue?vue&type=style&index=0&id=797ec22e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports